import React from "react";
import { PageNotFound } from '../PageNotFound'
class ErrorFound extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        //logErrorToMyService(error, errorInfo);
    }

    render() {
        if (!this.props.required && this.state.hasError) {
            // You can render any custom fallback UI
            return this.props.isAnalytics ? <h1>Something went wrong.</h1> : <PageNotFound />
        }

        return this.props.children;
    }
}

export default ErrorFound;